export const TENANT_STANDORT_RESET_PARAM = "tenantStandortReset";
export const TENANT_STANDORT_RESET_VALUE = "1";
export const TENANT_STANDORT_RESET_COOKIE = "tenantStandortReset";

const TENANT_STANDORT_RESET_COOKIE_PATH = "/ansprechpartner";

export type SearchParamValueT = string | string[] | undefined;

type TenantStandortDefaultOptionsT = {
  readonly defaultLocation?: string;
  readonly standortParam: SearchParamValueT;
  readonly tenantStandortResetParam: SearchParamValueT;
};

export const hasNonEmptySearchParamValue = (
  value: SearchParamValueT
): boolean => {
  if (typeof value === "string") {
    return value.trim().length > 0;
  }

  if (Array.isArray(value)) {
    return value.some((entry) => entry.trim().length > 0);
  }

  return false;
};

export const hasTenantStandortResetFlag = (
  value: SearchParamValueT
): boolean => {
  if (typeof value === "string") {
    return value === TENANT_STANDORT_RESET_VALUE;
  }

  if (Array.isArray(value)) {
    return value.includes(TENANT_STANDORT_RESET_VALUE);
  }

  return false;
};

export const shouldApplyTenantDefaultStandort = ({
  defaultLocation,
  standortParam,
  tenantStandortResetParam,
}: TenantStandortDefaultOptionsT): boolean =>
  Boolean(defaultLocation) &&
  !hasNonEmptySearchParamValue(standortParam) &&
  !hasTenantStandortResetFlag(tenantStandortResetParam);

export const resolveTenantStandortFallback = ({
  defaultLocation,
  standortParam,
  tenantStandortResetParam,
}: TenantStandortDefaultOptionsT): string | undefined =>
  shouldApplyTenantDefaultStandort({
    defaultLocation,
    standortParam,
    tenantStandortResetParam,
  })
    ? defaultLocation
    : undefined;

export const setTenantStandortResetCookie = () => {
  if (typeof document === "undefined") return;

  document.cookie = `${TENANT_STANDORT_RESET_COOKIE}=${TENANT_STANDORT_RESET_VALUE}; path=${TENANT_STANDORT_RESET_COOKIE_PATH}; max-age=300; samesite=lax`;
};

export const clearTenantStandortResetCookie = () => {
  if (typeof document === "undefined") return;

  document.cookie = `${TENANT_STANDORT_RESET_COOKIE}=; path=${TENANT_STANDORT_RESET_COOKIE_PATH}; max-age=0; samesite=lax`;
};
